export const radii = {
  none: 0,
  round: 999999999999999,
  xxs: 2,
  xs: 4,
  s: 8,
  m: 12,
  l: 24,
  xl: 32,
  xxl: 48,
};

export const borderWidths = {
  none: 0,
  xxs: 1,
  xs: 2,
  s: 4,
  m: 8,
  l: 16,
  xl: 32,
  xxl: 48,
};
